import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Rx';
import { ErrorHandlerService } from '../services';
import { LoginService } from "../login";
var UnsubscribeComponent = /** @class */ (function () {
    function UnsubscribeComponent(errorHandlerService, loginService, router, route, fb) {
        this.errorHandlerService = errorHandlerService;
        this.loginService = loginService;
        this.router = router;
        this.route = route;
        this.fb = fb;
        this.subscriptions = [];
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showLogOffModalDialog = false;
        this.showLogOffMessageTitle = "Session Expired. Logging off!";
        this.showLogOffMessages = [];
        this.showLogOffPopupWidthInPercentage = "20%";
        this.isSessionExpired = false;
        this.deleteduserAccessException = false;
        this.deleteduserAccessExceptionGoBackInHistory = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = true;
        this.pleaseWait = true;
        this.title = "We apologies for automated emails to your Inbox. We are taking your concern seriously. Please follow these steps to unsubscribe.";
        this.isOtpForm = true;
        this.email = "";
        this.unsubscribeForm = this.fb.group({
            emailId: [null, Validators.email]
        });
    }
    UnsubscribeComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    UnsubscribeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showSpinner = true;
        setTimeout(function () {
            _this.showSpinner = false;
        }, 1000);
    };
    UnsubscribeComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.unsubscribeForm.valid) {
            this.showSpinner = true;
            console.log('form', this.unsubscribeForm.value);
            this.email = this.unsubscribeForm.value.emailId;
            this.loginService.generateOtp(this.unsubscribeForm.value).subscribe(function (data) {
                console.log(data);
                _this.otpForm = _this.fb.group({
                    emailId: _this.email,
                    otp: [null, [Validators.required, Validators.pattern("^[0-9]{6}$")]]
                });
                _this.title = "Due to security reasons we have sent you an OTP to your email id:\"" + _this.email + "\". Didn't receive? please check your promotion or spam folders. The OTP is valid for 5 min.";
                _this.isOtpForm = false;
                _this.showSpinner = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
            });
        }
        else {
            this.validateAllFields(this.unsubscribeForm);
        }
    };
    UnsubscribeComponent.prototype.onSubmitOtp = function () {
        var _this = this;
        if (this.otpForm.valid) {
            this.showSpinner = true;
            console.log('form', this.otpForm.value);
            this.loginService.submitOtp(this.otpForm.value).subscribe(function (data) {
                console.log(data);
                _this.showSpinner = false;
                localStorage.setItem('accountActivationStatus', 'Unsubscribed.successful');
                _this.router.navigate(['/login']);
            }, function (error) {
                console.log(error);
                _this.handleError(error);
                _this.showSpinner = false;
            });
        }
        else {
            this.validateAllFields(this.otpForm);
        }
    };
    UnsubscribeComponent.prototype.validateAllFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFields(control);
            }
        });
    };
    UnsubscribeComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    UnsubscribeComponent.prototype.handleError = function (error) {
        var _this = this;
        // Clear the error message list. Everytime this is invoked, it will remove the existing errors.
        this.showLogOffMessages = [];
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        //if this is an error thrown due to user accessing a deleted user's profile
        if (error.userDeleted) {
            console.log("Deleted User Access Exception, catching error thrown from ViewProfileAuthGuard");
            this.showSpinner = true;
            this.showOnlyOverlay = true;
            this.deleteduserAccessException = true;
            this.showLogOffMessageTitle = "Validation Error !!";
            this.showLogOffMessages.push("Sorry, the user has deleted his / her account. We are unable to display his / her profile.");
            this.showLogOffPopupWidthInPercentage = "30%";
            this.showLogOffModalDialog = true;
            this.deleteduserAccessExceptionGoBackInHistory = false;
            return;
        }
        // if it's a info message
        if (error.isInfo) {
            console.log("Info Message");
            this.isValidationError = false;
            this.showSpinner = true;
            this.showOnlyOverlay = true;
            this.showLogOffMessageTitle = "Info";
            this.showLogOffMessages.push(error.infoMessage);
            this.showLogOffPopupWidthInPercentage = "30%";
            this.showLogOffModalDialog = true;
            return;
        }
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.deleteduserAccessException) {
                console.log("Deleted User Access Exception");
                this.deleteduserAccessException = true;
                this.showLogOffMessageTitle = "Validation Error !!";
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
                this.deleteduserAccessExceptionGoBackInHistory = true;
            }
            else if (errorJson.sessionExpired) {
                console.log("The session has expired, so will display the Session Logout Popup now");
                this.isSessionExpired = true;
                this.showLogOffMessages = ["The session expired. Logging off now! Please log in back to the application."];
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
            }
            else {
                if (this.isSessionExpired) {
                    // If session expired, and dialog is not open, display the dialog once more. This scenario though would be
                    // hard to come by as the page will redirect to Login screen once the user closes the dialog.
                    if (!this.showLogOffModalDialog) {
                        console.log("The session has expired, so will display the Session Logout Popup now");
                        this.isSessionExpired = true;
                        this.showLogOffMessages = ["The session expired. Logging off now! Please log in back to the application."];
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                    }
                }
                else {
                    if (errorJson.Uvsity_Errors) {
                        console.log("Uvsity Exception");
                        this.showLogOffMessageTitle = "Validation Error !!";
                        errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                    }
                    else if (errorJson.Uvsity_Errors_Stacktrace) {
                        console.log("Uvsity Exception containing stacktrace");
                        this.showLogOffMessageTitle = "Validation Error !!";
                        errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                        this.isValidationError = false;
                    }
                    else {
                        console.log("Not Uvsity Exception");
                        this.showLogOffMessageTitle = "Unknown Error !!";
                        this.showLogOffMessages.push("An unexpected error occurred, Please try after sometime.");
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                    }
                }
            }
        }
        else {
            var errorJson = error;
            if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                this.showLogOffMessageTitle = "Validation Error !!";
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showLogOffMessageTitle = "Unknown Error !!";
                this.showLogOffMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
            }
        }
    };
    UnsubscribeComponent.prototype.closeErrorMessagePopup = function () {
        console.log("After closing Error Popup");
        // Trying to access whose account has been deleted.
        if (this.deleteduserAccessException) {
            // Cannot view the User's profile, go back to where you came from.
            this.deleteduserAccessException = false;
            this.showSpinner = false;
            this.showOnlyOverlay = false;
            this.showLogOffModalDialog = false;
            this.showLogOffMessages = [];
        }
        else if (this.isSessionExpired) {
            console.log("Session expired, About to Logout");
            this.isSessionExpired = false;
        }
        else {
            console.log("Session did not expire, will remove the overlay");
            this.showSpinner = false;
            this.showOnlyOverlay = false;
            this.showLogOffModalDialog = false;
            this.showLogOffMessages = [];
        }
    };
    UnsubscribeComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return UnsubscribeComponent;
}());
export { UnsubscribeComponent };
//# sourceMappingURL=unsubscribe.component.js.map